import { render, staticRenderFns } from "./cadastrar-cliente.vue?vue&type=template&id=0354ea9f&scoped=true&"
import script from "./cadastrar-cliente.vue?vue&type=script&lang=js&"
export * from "./cadastrar-cliente.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar-cliente.vue?vue&type=style&index=0&id=0354ea9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354ea9f",
  null
  
)

export default component.exports